import React from 'react';
import { Tooltip } from 'antd';

import { CloseOutlined } from '@ant-design/icons';
import { red } from '@ant-design/colors';

export const ServerErrorIndicator = ({ serverError }) => {
  return (
    <div
      style={{
        color: red[6],
        text: 'white',
        padding: 4,
        fontSize: 'medium',
        visibility: !serverError ? 'hidden' : 'visible',
      }}
    >
      <Tooltip
        title='Server Error! Please update and re-validate'
        color={red[5]}
        overlayStyle={{ minWidth: 270 }}
      >
        <CloseOutlined />
      </Tooltip>
    </div>
  );
};
